import { expVal } from '@atlassian/jira-feature-experiments';

const CustomTemplateForStandardAndPremiumRelayProvider = {
	get(): boolean {
		return expVal('custom_template_for_standard_and_premium', 'isEnabled', false);
	},
};

export default CustomTemplateForStandardAndPremiumRelayProvider;
